import { ColoredButton } from '@components/colored-elements';
import { IngestionMethodChip } from '@components/ingestion-method';
import { RelationSourceChip } from '@components/relation-source-chip';
import { rbac } from '@lib/common';
import { Grid } from '@material-ui/core';
import {
  lightGreen, red
} from '@material-ui/core/colors';
import CancelIcon from '@material-ui/icons/CancelRounded';
import SaveIcon from '@material-ui/icons/SaveRounded';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { QPIngestionMethod, QPSourceType } from '../quotes-policies.enums';

export function FormActions({
  submitForm = null,
  createQPRelation =false,
  qpData
}) {
  const history = useHistory();
  const form = useFormContext();

  const onSave = useCallback(() => {
    submitForm && submitForm(form.getValues());
  }, [submitForm]);

  return (
    <Grid container spacing={2} justify="space-between">
      <Grid item xs>
        <Grid container>
          {
            <>
            {/*   <RelationSourceChip type={createQPRelation ? QPSourceType.Vitrina : qpData?.source} /> */}
              &nbsp; &nbsp;
              <IngestionMethodChip
                type={createQPRelation ? QPIngestionMethod.DELI : qpData?.ingestion_method}
              />{' '}
              &nbsp; &nbsp;
             {/*  <RelationSourceChip
                type={createQPRelation ? QPSourceType.Vitrina : qpData?.updated_by}
              /> */}
            </>
          }
        </Grid>
      </Grid>
      <Grid item>
        <ColoredButton
          colored={red[500]}
          coloredHover={red[900]}
          startIcon={<CancelIcon />}
          variant="contained"
          size="small"
          // className={classes.paddingAll}
          onClick={() => history.push('/quotes-policies/search')}>
          Cancel
        </ColoredButton>
      </Grid>
      <Grid item>
        <ColoredButton
          colored={lightGreen[700]}
          coloredHover={lightGreen[900]}
          startIcon={<SaveIcon />}
          variant="contained"
          size="small"
          disabled={rbac('QP_New', '', 'Button')}
          onClick={onSave}>
          Save
        </ColoredButton>
      </Grid>
    </Grid>
  );
}
